module.exports = __webpack_public_path__ + "static/media/bmftr_logo_en.63127b12.svg";